module.exports = __webpack_public_path__ + "static/media/spinach.2920784a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/spinach.jpg
// module id = 135
// module chunks = 0